import { Alert, Button } from 'react-bootstrap';
import { getInfrastructureErrorCopy } from 'utils/apiErrors';

export default function ServiceUnavailableAlert({ error, onRetry, stale = false }) {
  const copy = getInfrastructureErrorCopy(error, { stale });

  if (!copy) return null;

  return (
    <Alert
      variant={stale ? 'warning' : 'danger'}
      className="text-center mt-2 w-75 mx-auto"
      role="alert"
    >
      <p className="mb-1 fw-semibold">{copy.title}</p>
      <p className="mb-0">{copy.description}</p>
      {onRetry ? (
        <Button
          variant={stale ? 'outline-warning' : 'outline-danger'}
          size="sm"
          className="mt-2"
          onClick={onRetry}
        >
          Tentar novamente
        </Button>
      ) : null}
    </Alert>
  );
}
